import { get } from "lodash-es";
import type { Maybe, GetGameLeadersQuery } from "@/graphql/gql/graphql";
type TeamLeadersT = NonNullable<GetGameLeadersQuery["event"]>["homeTeam"];

export const teamGameLeaders = (team?: Maybe<TeamLeadersT>) => {
  const stats = get(team, "gameLeaders", {});

  return {
    passing_leader: {
      abbreviation: get(team, "abbreviation", ""),
      logoSVG: get(team, "logoSVG", ""),
      jerseySVG: get(team, "teamJerseySVG", ""),
      name: get(stats, "passing.name", ""),
      position: get(stats, "passing.position", ""),
    },
    passing_throws: {
      passing_attempts: get(stats, "passing.attempts", 0),
      passing_completions: get(stats, "passing.completions", 0),
    },
    passing_yards: get(stats, "passing.yards", 0),
    passing_touchdowns: get(stats, "passing.touchdowns", 0),
    rushing_leader: {
      abbreviation: get(team, "abbreviation", ""),
      logoSVG: get(team, "logoSVG", ""),
      jerseySVG: get(team, "teamJerseySVG", ""),
      name: get(stats, "rushing.name", ""),
      position: get(stats, "rushing.position", ""),
    },
    rushing_carries: get(stats, "rushing.carries", 0),
    rushing_yards: get(stats, "rushing.yards", 0),
    rushing_touchdowns: get(stats, "rushing.touchdowns", 0),
    receiving_leader: {
      abbreviation: get(team, "abbreviation", ""),
      logoSVG: get(team, "logoSVG", ""),
      jerseySVG: get(team, "teamJerseySVG", ""),
      name: get(stats, "receiving.name", ""),
      position: get(stats, "receiving.position", ""),
    },
    receiving_targets: get(stats, "receiving.targets", 0),
    receiving_receptions: get(stats, "receiving.receptions", 0),
    receiving_yards: get(stats, "receiving.yards", 0),
    receiving_touchdowns: get(stats, "receiving.touchdowns", 0),
  };
};

export const createTableData = (data?: GetGameLeadersQuery["event"]) => {
  const homeTeam = data?.homeTeam;
  const awayTeam = data?.awayTeam;
  const homeStats = teamGameLeaders(homeTeam);
  const awayStats = teamGameLeaders(awayTeam);

  return [homeStats, awayStats];
};
